import {
    useMemo,
} from 'react'
import {
    useLocation,
} from 'react-router-dom'

import Card from 'app/shared-components/Card'
import {
    useArchivedTableControl,
} from 'app/shared-components/TableControls/ShowArchived'
import CollapsibleTable from 'app/shared-components/CollapsibleTable'

import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import useHasPermission from 'app/hooks/useHasPermission'
import useStyles from 'app/tss/collapsibleTable.styles'
import ContractBasisContextWrapper from '../ContractBasisContextWrapper/ContractBasisContextWrapper'

import useGetAdditionalFeesByContractBasisId from './hooks/useGetAdditionalFees'
import AdditionalFeesCopy from './AdditionalFeesCopy'
import AdditionalFeesCreate from './AdditionalFeesCreate'
import AdditionalFeesUpdate from './AdditionalFeesUpdate'
import columns from './additionalFees.columns'

type Props = {
    id: number,
}

const AdditionalFees = ({
    id,
}: Props) => {
    const {
        ContractBasis: ContractBasisRoutes,
    } = usePricingRoutes()
    const contractBasisCreate = useHasPermission(['contract_basis_create'])
    const {
        classes,
    } = useStyles()

    const {
        pathname,
    } = useLocation()

    const showArchivedFromUrl = pathname.includes('additionalfee-archived')
    const showArchived = useArchivedTableControl('AdditionalFees')

    const requestsHandlers = useGetAdditionalFeesByContractBasisId({
        id,
        showArchived: showArchived || showArchivedFromUrl,
    })

    const actionComponents = useMemo(() => {
        return {
            Copy: AdditionalFeesCopy,
            Update: AdditionalFeesUpdate,
            Create: contractBasisCreate ? AdditionalFeesCreate : undefined,
        }
    }, [contractBasisCreate])

    return (
        <ContractBasisContextWrapper id={id}>
            <div
                data-testid="additionalFees"
                className={classes.root}
            >
                <Card
                    fullHeight
                    contentClass={classes.cardContent}
                    data-testid="additionalFees-card"
                >
                    <CollapsibleTable
                        title="Additional Fees"
                        domainName="AdditionalFees"
                        requestHandlers={requestsHandlers}
                        actionComponents={actionComponents}
                        createEnabled={contractBasisCreate}
                        columns={columns}
                        radioSelect
                        uniqField="additionalFeesNumber"
                        routeParams={ContractBasisRoutes.AdditionalFees.params.map(({
                            name,
                        }) => {
                            return name
                        })}
                    />
                </Card>
            </div>
        </ContractBasisContextWrapper>
    )
}

export default AdditionalFees
